import type { ReactNode } from 'react';
import { AccessDeniedPage } from '../features/common/pages/AccessDeniedPage.js';
import { useAuth } from '../lib/auth-context.js';
import { isCustomerAdmin } from '../lib/roles.js';

/**
 * Route gate for the admin-only pages (Planning backup/restore, custom forms
 * migration). The customer API enforces the same rule with a 403; this keeps a
 * viewer from landing on a page whose every request would fail.
 */
export function RequireCustomerAdmin({ children }: { children: ReactNode }): JSX.Element {
  const { session } = useAuth();
  if (!isCustomerAdmin(session)) {
    return (
      <AccessDeniedPage message="Only Workfront System Administrators of this license can open this page." />
    );
  }
  return <>{children}</>;
}
